import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ThankYou() {
  const [count, setCount] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    if (count === 0) {
      navigate("/");
      return;
    }
    const t = setTimeout(() => setCount((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [count, navigate]);

  return (
    <section data-testid="thank-you-page" className="min-h-[85vh] bg-ivory flex items-center">
      <div className="max-w-[1000px] mx-auto px-6 md:px-10 py-24 text-center">
        <p className="eyebrow eyebrow-brass mb-8">Received</p>

        <h1
          data-testid="thank-you-headline"
          className="font-display leading-[1.05] uppercase"
          style={{
            fontSize: "clamp(38px, 6.5vw, 96px)",
            fontWeight: 300,
            letterSpacing: "0.02em",
          }}
        >
          Thank you for shaping the <em className="italic">house.</em>
        </h1>

        <p className="mt-10 font-display text-2xl md:text-3xl text-ink leading-[1.45]" data-testid="thank-you-line-2">
          You're on the list now, first to know when it arrives.
        </p>

        <p className="mt-6 text-pencil text-sm" data-testid="thank-you-line-3">
          We'll be quiet until then.
        </p>

        <p className="mt-16 font-mono-stamp text-pencil" data-testid="thank-you-countdown">
          Redirecting you to the homepage in {count}...
        </p>
      </div>
    </section>
  );
}
